export const submenuIndicatorDirection = (vertical: boolean) => (vertical ? {} : { transform: `rotate(90deg)` });
